import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import timelineItems from "../Constants/TimeLineData";

const TimeLine = () => {
  return (
    <VerticalTimeline lineColor="var(--accent)">
      {timelineItems.map((item, index) => (
        <VerticalTimelineElement
          key={index}
          className={`vertical-timeline-element--${item.position}`}
          date={item.date}
          iconStyle={{ background: 'var(--accent)', color: '#fff' }}
          contentStyle={{ background: 'var(--bg-card)', color: 'var(--text)', border: '1px solid var(--border)', boxShadow: 'none', borderRadius: '1rem' }}
          contentArrowStyle={{ borderRight: '7px solid var(--border)' }}
          icon={item.icon}
        >
          <h3 className="vertical-timeline-element-title text-xl font-bold" style={{ color: 'var(--text)' }}>{item.title}</h3>
          {item.subTitle && <h4 className="vertical-timeline-element-subtitle text-base mt-1" style={{ color: 'var(--accent)' }}>{item.subTitle}</h4>}
          {item.description && <p className="text-sm mt-2" style={{ color: 'var(--text-muted)' }}>{item.description}</p>}
        </VerticalTimelineElement>
      ))}
    </VerticalTimeline>
  )
}

export default TimeLine
